import { render, staticRenderFns } from "./TeacherTitling.vue?vue&type=template&id=fd7dfe1a"
import script from "./TeacherTitling.vue?vue&type=script&lang=js"
export * from "./TeacherTitling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports